import i18n from './../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";

export default class CheckModel extends BaseModel {
  date = null;
  starting_check_number = null;
  beneficiary_relation_uuid = null;
  amount = null;
  description = null;
  reference_number = null;
  reconciled = null;
  bank_account = null;


  static TRANSLATABLE_FIELDS = [];

  rules = {};

  attributeLabels = {
    date: i18n.t('Date'),
    starting_check_number: i18n.t('Starting check number'),
    beneficiary_relation_uuid: i18n.t('Beneficiaries'),
    amount: i18n.t('Amount'),
    description: i18n.t('Description'),
    reference_number: i18n.t('Reference Number'),
    reconciled: i18n.t('Reconciled'),
    bank_account: i18n.t('Bank Account'),
  };

  attributeHints = {}

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}

defineTranslatableProperties(CheckModel);
